module.exports = __webpack_public_path__ + "img/1f420.69f2cf7.svg";